module.exports = __webpack_public_path__ + "911130f8face4148982b621e2dcd4467.pdf";